import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import IndividualSubjectPerformance from "./routes/IndividualSubjectPerformance";
export default store => {
  return {
    path: "subject",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "subject" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [IndividualSubjectPerformance(store)],
  };
};
